import { useModal } from '@ebay/nice-modal-react'
import { useCallback, useEffect } from 'react'

import { MessageModal } from '../components/common'
import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'
import closeModal from '../utils/closeModal'

const useWhatsApp = () => {
  const setUser = useBoundStore(state => state.user.setUser)
  const username = useBoundStore(state => state.user.username)
  const isLoading = useBoundStore(state => state.user.isLoading)
  const clicked = useBoundStore(state => state.user.whatsapp_url)
  const label = useBoundStore(state => state.settings.whatsapp_text.value)
  const url = useBoundStore(state => state.settings.whatsapp_url)
  const messageModal = useModal(MessageModal)

  const handleClickWhatsapp = useCallback(() => {
    api.post<ApiResponse<object>>('/center.php', {
      submit_type: 'whatsapp_clicked',
      whatsapp_url: url,
    })
    setUser({ whatsapp_url: url })
    closeModal(messageModal)
  }, [url])

  useEffect(() => {
    if (!label || isLoading) return
    if (username && url && !clicked) {
      messageModal.show({
        message: (
          <div>
            <p className="text-txt text-center mb-2">{label}</p>
            <a
              className="text-center w-full text-highlight underline block break-words"
              href={url}
              target="blank"
              onClick={handleClickWhatsapp}
              aria-label={`Contact us on WhatsApp at ${url}`}>
              {url}
            </a>
          </div>
        ),
      })
    }
  }, [isLoading, label])
}

export default useWhatsApp
